import axios from '../axios'

export default class AppSettingsService {
  getSetting(key) {
    return new Promise(async function (resolve, reject) {
      try {
        var path = '/v1/appSettings/' + key
        var response = await axios.get(path)
        resolve(response.data)
      } catch (err) {
        reject(err)
      }
    })
  }

  updateSetting(key, value) {
    return new Promise(async function (resolve, reject) {
      try {
        var path = '/v1/appSettings/' + key
        var response = await axios.put(path, { settingValue: value })
        resolve(response.data)
      } catch (err) {
        reject(err)
      }
    })
  }
}
